export const resources = {
    rosters: {
        //endpoint: "https://rosters-latest.apps.ocpprd01.mcmaster.ca/timetables/",
        endpoint: "https://rosters-stable.apps.ocpprd01.mcmaster.ca/timetables/",
        scopes: [
            "https://mcmaster.ca/rosters/Timetables.Read"
        ]
    },
    holidays: {
        // endpoint: "https://apis.mcmaster.ca/mcmaster-university/sandbox/holidays/MACUG/UGRD/",
        endpoint: "https://rosters-stable.apps.ocpprd01.mcmaster.ca/holidays/MACUG/UGRD/",
    },
    graph: {
        endpoint: "me/calendars/",
        calendarName: "Calendar",
        scopes: [
            "User.Read",
            "Calendars.ReadWrite",
            "https://mcmaster.ca/rosters/Timetables.Read"
        ]
    }
};